// Timezones supported in Node 12

export default [
    { value: 'Africa/Abidjan', key: 'timezones.Africa-Abidjan' },
    { value: 'Africa/Accra', key: 'timezones.Africa-Accra' },
    { value: 'Africa/Addis_Ababa', key: 'timezones.Africa-Addis_Ababa' },
    { value: 'Africa/Algiers', key: 'timezones.Africa-Algiers' },
    { value: 'Africa/Asmara', key: 'timezones.Africa-Asmara' },
    { value: 'Africa/Asmera', key: 'timezones.Africa-Asmera' },
    { value: 'Africa/Bamako', key: 'timezones.Africa-Bamako' },
    { value: 'Africa/Bangui', key: 'timezones.Africa-Bangui' },
    { value: 'Africa/Banjul', key: 'timezones.Africa-Banjul' },
    { value: 'Africa/Bissau', key: 'timezones.Africa-Bissau' },
    { value: 'Africa/Blantyre', key: 'timezones.Africa-Blantyre' },
    { value: 'Africa/Brazzaville', key: 'timezones.Africa-Brazzaville' },
    { value: 'Africa/Bujumbura', key: 'timezones.Africa-Bujumbura' },
    { value: 'Africa/Cairo', key: 'timezones.Africa-Cairo' },
    { value: 'Africa/Casablanca', key: 'timezones.Africa-Casablanca' },
    { value: 'Africa/Ceuta', key: 'timezones.Africa-Ceuta' },
    { value: 'Africa/Conakry', key: 'timezones.Africa-Conakry' },
    { value: 'Africa/Dakar', key: 'timezones.Africa-Dakar' },
    { value: 'Africa/Dar_es_Salaam', key: 'timezones.Africa-Dar_es_Salaam' },
    { value: 'Africa/Djibouti', key: 'timezones.Africa-Djibouti' },
    { value: 'Africa/Douala', key: 'timezones.Africa-Douala' },
    { value: 'Africa/El_Aaiun', key: 'timezones.Africa-El_Aaiun' },
    { value: 'Africa/Freetown', key: 'timezones.Africa-Freetown' },
    { value: 'Africa/Gaborone', key: 'timezones.Africa-Gaborone' },
    { value: 'Africa/Harare', key: 'timezones.Africa-Harare' },
    { value: 'Africa/Johannesburg', key: 'timezones.Africa-Johannesburg' },
    { value: 'Africa/Juba', key: 'timezones.Africa-Juba' },
    { value: 'Africa/Kampala', key: 'timezones.Africa-Kampala' },
    { value: 'Africa/Khartoum', key: 'timezones.Africa-Khartoum' },
    { value: 'Africa/Kigali', key: 'timezones.Africa-Kigali' },
    { value: 'Africa/Kinshasa', key: 'timezones.Africa-Kinshasa' },
    { value: 'Africa/Lagos', key: 'timezones.Africa-Lagos' },
    { value: 'Africa/Libreville', key: 'timezones.Africa-Libreville' },
    { value: 'Africa/Lome', key: 'timezones.Africa-Lome' },
    { value: 'Africa/Luanda', key: 'timezones.Africa-Luanda' },
    { value: 'Africa/Lubumbashi', key: 'timezones.Africa-Lubumbashi' },
    { value: 'Africa/Lusaka', key: 'timezones.Africa-Lusaka' },
    { value: 'Africa/Malabo', key: 'timezones.Africa-Malabo' },
    { value: 'Africa/Maputo', key: 'timezones.Africa-Maputo' },
    { value: 'Africa/Maseru', key: 'timezones.Africa-Maseru' },
    { value: 'Africa/Mbabane', key: 'timezones.Africa-Mbabane' },
    { value: 'Africa/Mogadishu', key: 'timezones.Africa-Mogadishu' },
    { value: 'Africa/Monrovia', key: 'timezones.Africa-Monrovia' },
    { value: 'Africa/Nairobi', key: 'timezones.Africa-Nairobi' },
    { value: 'Africa/Ndjamena', key: 'timezones.Africa-Ndjamena' },
    { value: 'Africa/Niamey', key: 'timezones.Africa-Niamey' },
    { value: 'Africa/Nouakchott', key: 'timezones.Africa-Nouakchott' },
    { value: 'Africa/Ouagadougou', key: 'timezones.Africa-Ouagadougou' },
    { value: 'Africa/Porto-Novo', key: 'timezones.Africa-Porto-Novo' },
    { value: 'Africa/Sao_Tome', key: 'timezones.Africa-Sao_Tome' },
    { value: 'Africa/Timbuktu', key: 'timezones.Africa-Timbuktu' },
    { value: 'Africa/Tripoli', key: 'timezones.Africa-Tripoli' },
    { value: 'Africa/Tunis', key: 'timezones.Africa-Tunis' },
    { value: 'Africa/Windhoek', key: 'timezones.Africa-Windhoek' },
    { value: 'America/Adak', key: 'timezones.America-Adak' },
    { value: 'America/Anchorage', key: 'timezones.America-Anchorage' },
    { value: 'America/Anguilla', key: 'timezones.America-Anguilla' },
    { value: 'America/Antigua', key: 'timezones.America-Antigua' },
    { value: 'America/Araguaina', key: 'timezones.America-Araguaina' },
    { value: 'America/Argentina/Buenos_Aires', key: 'timezones.America-Argentina-Buenos_Aires' },
    { value: 'America/Argentina/Catamarca', key: 'timezones.America-Argentina-Catamarca' },
    { value: 'America/Argentina/Cordoba', key: 'timezones.America-Argentina-Cordoba' },
    { value: 'America/Argentina/Jujuy', key: 'timezones.America-Argentina-Jujuy' },
    { value: 'America/Argentina/La_Rioja', key: 'timezones.America-Argentina-La_Rioja' },
    { value: 'America/Argentina/Mendoza', key: 'timezones.America-Argentina-Mendoza' },
    { value: 'America/Argentina/Rio_Gallegos', key: 'timezones.America-Argentina-Rio_Gallegos' },
    { value: 'America/Argentina/Salta', key: 'timezones.America-Argentina-Salta' },
    { value: 'America/Argentina/San_Juan', key: 'timezones.America-Argentina-San_Juan' },
    { value: 'America/Argentina/San_Luis', key: 'timezones.America-Argentina-San_Luis' },
    { value: 'America/Argentina/Tucuman', key: 'timezones.America-Argentina-Tucuman' },
    { value: 'America/Argentina/Ushuaia', key: 'timezones.America-Argentina-Ushuaia' },
    { value: 'America/Aruba', key: 'timezones.America-Aruba' },
    { value: 'America/Asuncion', key: 'timezones.America-Asuncion' },
    { value: 'America/Atikokan', key: 'timezones.America-Atikokan' },
    { value: 'America/Atka', key: 'timezones.America-Atka' },
    { value: 'America/Bahia', key: 'timezones.America-Bahia' },
    { value: 'America/Bahia_Banderas', key: 'timezones.America-Bahia_Banderas' },
    { value: 'America/Barbados', key: 'timezones.America-Barbados' },
    { value: 'America/Belem', key: 'timezones.America-Belem' },
    { value: 'America/Belize', key: 'timezones.America-Belize' },
    { value: 'America/Blanc-Sablon', key: 'timezones.America-Blanc-Sablon' },
    { value: 'America/Boa_Vista', key: 'timezones.America-Boa_Vista' },
    { value: 'America/Bogota', key: 'timezones.America-Bogota' },
    { value: 'America/Boise', key: 'timezones.America-Boise' },
    { value: 'America/Buenos_Aires', key: 'timezones.America-Buenos_Aires' },
    { value: 'America/Cambridge_Bay', key: 'timezones.America-Cambridge_Bay' },
    { value: 'America/Campo_Grande', key: 'timezones.America-Campo_Grande' },
    { value: 'America/Cancun', key: 'timezones.America-Cancun' },
    { value: 'America/Caracas', key: 'timezones.America-Caracas' },
    { value: 'America/Catamarca', key: 'timezones.America-Catamarca' },
    { value: 'America/Cayenne', key: 'timezones.America-Cayenne' },
    { value: 'America/Cayman', key: 'timezones.America-Cayman' },
    { value: 'America/Chicago', key: 'timezones.America-Chicago' },
    { value: 'America/Chihuahua', key: 'timezones.America-Chihuahua' },
    { value: 'America/Coral_Harbour', key: 'timezones.America-Coral_Harbour' },
    { value: 'America/Cordoba', key: 'timezones.America-Cordoba' },
    { value: 'America/Costa_Rica', key: 'timezones.America-Costa_Rica' },
    { value: 'America/Creston', key: 'timezones.America-Creston' },
    { value: 'America/Cuiaba', key: 'timezones.America-Cuiaba' },
    { value: 'America/Curacao', key: 'timezones.America-Curacao' },
    { value: 'America/Danmarkshavn', key: 'timezones.America-Danmarkshavn' },
    { value: 'America/Dawson', key: 'timezones.America-Dawson' },
    { value: 'America/Dawson_Creek', key: 'timezones.America-Dawson_Creek' },
    { value: 'America/Denver', key: 'timezones.America-Denver' },
    { value: 'America/Detroit', key: 'timezones.America-Detroit' },
    { value: 'America/Dominica', key: 'timezones.America-Dominica' },
    { value: 'America/Edmonton', key: 'timezones.America-Edmonton' },
    { value: 'America/Eirunepe', key: 'timezones.America-Eirunepe' },
    { value: 'America/El_Salvador', key: 'timezones.America-El_Salvador' },
    { value: 'America/Ensenada', key: 'timezones.America-Ensenada' },
    { value: 'America/Fort_Nelson', key: 'timezones.America-Fort_Nelson' },
    { value: 'America/Fort_Wayne', key: 'timezones.America-Fort_Wayne' },
    { value: 'America/Fortaleza', key: 'timezones.America-Fortaleza' },
    { value: 'America/Glace_Bay', key: 'timezones.America-Glace_Bay' },
    { value: 'America/Godthab', key: 'timezones.America-Godthab' },
    { value: 'America/Goose_Bay', key: 'timezones.America-Goose_Bay' },
    { value: 'America/Grand_Turk', key: 'timezones.America-Grand_Turk' },
    { value: 'America/Grenada', key: 'timezones.America-Grenada' },
    { value: 'America/Guadeloupe', key: 'timezones.America-Guadeloupe' },
    { value: 'America/Guatemala', key: 'timezones.America-Guatemala' },
    { value: 'America/Guayaquil', key: 'timezones.America-Guayaquil' },
    { value: 'America/Guyana', key: 'timezones.America-Guyana' },
    { value: 'America/Halifax', key: 'timezones.America-Halifax' },
    { value: 'America/Havana', key: 'timezones.America-Havana' },
    { value: 'America/Hermosillo', key: 'timezones.America-Hermosillo' },
    { value: 'America/Indiana/Indianapolis', key: 'timezones.America-Indiana-Indianapolis' },
    { value: 'America/Indiana/Knox', key: 'timezones.America-Indiana-Knox' },
    { value: 'America/Indiana/Marengo', key: 'timezones.America-Indiana-Marengo' },
    { value: 'America/Indiana/Petersburg', key: 'timezones.America-Indiana-Petersburg' },
    { value: 'America/Indiana/Tell_City', key: 'timezones.America-Indiana-Tell_City' },
    { value: 'America/Indiana/Vevay', key: 'timezones.America-Indiana-Vevay' },
    { value: 'America/Indiana/Vincennes', key: 'timezones.America-Indiana-Vincennes' },
    { value: 'America/Indiana/Winamac', key: 'timezones.America-Indiana-Winamac' },
    { value: 'America/Indianapolis', key: 'timezones.America-Indianapolis' },
    { value: 'America/Inuvik', key: 'timezones.America-Inuvik' },
    { value: 'America/Iqaluit', key: 'timezones.America-Iqaluit' },
    { value: 'America/Jamaica', key: 'timezones.America-Jamaica' },
    { value: 'America/Jujuy', key: 'timezones.America-Jujuy' },
    { value: 'America/Juneau', key: 'timezones.America-Juneau' },
    { value: 'America/Kentucky/Louisville', key: 'timezones.America-Kentucky-Louisville' },
    { value: 'America/Kentucky/Monticello', key: 'timezones.America-Kentucky-Monticello' },
    { value: 'America/Kralendijk', key: 'timezones.America-Kralendijk' },
    { value: 'America/La_Paz', key: 'timezones.America-La_Paz' },
    { value: 'America/Lima', key: 'timezones.America-Lima' },
    { value: 'America/Los_Angeles', key: 'timezones.America-Los_Angeles' },
    { value: 'America/Louisville', key: 'timezones.America-Louisville' },
    { value: 'America/Lower_Princes', key: 'timezones.America-Lower_Princes' },
    { value: 'America/Maceio', key: 'timezones.America-Maceio' },
    { value: 'America/Managua', key: 'timezones.America-Managua' },
    { value: 'America/Manaus', key: 'timezones.America-Manaus' },
    { value: 'America/Marigot', key: 'timezones.America-Marigot' },
    { value: 'America/Martinique', key: 'timezones.America-Martinique' },
    { value: 'America/Matamoros', key: 'timezones.America-Matamoros' },
    { value: 'America/Mazatlan', key: 'timezones.America-Mazatlan' },
    { value: 'America/Mendoza', key: 'timezones.America-Mendoza' },
    { value: 'America/Menominee', key: 'timezones.America-Menominee' },
    { value: 'America/Merida', key: 'timezones.America-Merida' },
    { value: 'America/Metlakatla', key: 'timezones.America-Metlakatla' },
    { value: 'America/Mexico_City', key: 'timezones.America-Mexico_City' },
    { value: 'America/Miquelon', key: 'timezones.America-Miquelon' },
    { value: 'America/Moncton', key: 'timezones.America-Moncton' },
    { value: 'America/Monterrey', key: 'timezones.America-Monterrey' },
    { value: 'America/Montevideo', key: 'timezones.America-Montevideo' },
    { value: 'America/Montreal', key: 'timezones.America-Montreal' },
    { value: 'America/Montserrat', key: 'timezones.America-Montserrat' },
    { value: 'America/Nassau', key: 'timezones.America-Nassau' },
    { value: 'America/New_York', key: 'timezones.America-New_York' },
    { value: 'America/Nipigon', key: 'timezones.America-Nipigon' },
    { value: 'America/Nome', key: 'timezones.America-Nome' },
    { value: 'America/Noronha', key: 'timezones.America-Noronha' },
    { value: 'America/North_Dakota/Beulah', key: 'timezones.America-North_Dakota-Beulah' },
    { value: 'America/North_Dakota/Center', key: 'timezones.America-North_Dakota-Center' },
    { value: 'America/North_Dakota/New_Salem', key: 'timezones.America-North_Dakota-New_Salem' },
    { value: 'America/Ojinaga', key: 'timezones.America-Ojinaga' },
    { value: 'America/Panama', key: 'timezones.America-Panama' },
    { value: 'America/Pangnirtung', key: 'timezones.America-Pangnirtung' },
    { value: 'America/Paramaribo', key: 'timezones.America-Paramaribo' },
    { value: 'America/Phoenix', key: 'timezones.America-Phoenix' },
    { value: 'America/Port-au-Prince', key: 'timezones.America-Port-au-Prince' },
    { value: 'America/Port_of_Spain', key: 'timezones.America-Port_of_Spain' },
    { value: 'America/Porto_Acre', key: 'timezones.America-Porto_Acre' },
    { value: 'America/Porto_Velho', key: 'timezones.America-Porto_Velho' },
    { value: 'America/Puerto_Rico', key: 'timezones.America-Puerto_Rico' },
    { value: 'America/Punta_Arenas', key: 'timezones.America-Punta_Arenas' },
    { value: 'America/Rainy_River', key: 'timezones.America-Rainy_River' },
    { value: 'America/Rankin_Inlet', key: 'timezones.America-Rankin_Inlet' },
    { value: 'America/Recife', key: 'timezones.America-Recife' },
    { value: 'America/Regina', key: 'timezones.America-Regina' },
    { value: 'America/Resolute', key: 'timezones.America-Resolute' },
    { value: 'America/Rio_Branco', key: 'timezones.America-Rio_Branco' },
    { value: 'America/Rosario', key: 'timezones.America-Rosario' },
    { value: 'America/Santa_Isabel', key: 'timezones.America-Santa_Isabel' },
    { value: 'America/Santarem', key: 'timezones.America-Santarem' },
    { value: 'America/Santiago', key: 'timezones.America-Santiago' },
    { value: 'America/Santo_Domingo', key: 'timezones.America-Santo_Domingo' },
    { value: 'America/Sao_Paulo', key: 'timezones.America-Sao_Paulo' },
    { value: 'America/Scoresbysund', key: 'timezones.America-Scoresbysund' },
    { value: 'America/Shiprock', key: 'timezones.America-Shiprock' },
    { value: 'America/Sitka', key: 'timezones.America-Sitka' },
    { value: 'America/St_Barthelemy', key: 'timezones.America-St_Barthelemy' },
    { value: 'America/St_Johns', key: 'timezones.America-St_Johns' },
    { value: 'America/St_Kitts', key: 'timezones.America-St_Kitts' },
    { value: 'America/St_Lucia', key: 'timezones.America-St_Lucia' },
    { value: 'America/St_Thomas', key: 'timezones.America-St_Thomas' },
    { value: 'America/St_Vincent', key: 'timezones.America-St_Vincent' },
    { value: 'America/Swift_Current', key: 'timezones.America-Swift_Current' },
    { value: 'America/Tegucigalpa', key: 'timezones.America-Tegucigalpa' },
    { value: 'America/Thule', key: 'timezones.America-Thule' },
    { value: 'America/Thunder_Bay', key: 'timezones.America-Thunder_Bay' },
    { value: 'America/Tijuana', key: 'timezones.America-Tijuana' },
    { value: 'America/Toronto', key: 'timezones.America-Toronto' },
    { value: 'America/Tortola', key: 'timezones.America-Tortola' },
    { value: 'America/Vancouver', key: 'timezones.America-Vancouver' },
    { value: 'America/Virgin', key: 'timezones.America-Virgin' },
    { value: 'America/Whitehorse', key: 'timezones.America-Whitehorse' },
    { value: 'America/Winnipeg', key: 'timezones.America-Winnipeg' },
    { value: 'America/Yakutat', key: 'timezones.America-Yakutat' },
    { value: 'America/Yellowknife', key: 'timezones.America-Yellowknife' },
    { value: 'Antarctica/Casey', key: 'timezones.Antarctica-Casey' },
    { value: 'Antarctica/Davis', key: 'timezones.Antarctica-Davis' },
    { value: 'Antarctica/DumontDUrville', key: 'timezones.Antarctica-DumontDUrville' },
    { value: 'Antarctica/Macquarie', key: 'timezones.Antarctica-Macquarie' },
    { value: 'Antarctica/Mawson', key: 'timezones.Antarctica-Mawson' },
    { value: 'Antarctica/Palmer', key: 'timezones.Antarctica-Palmer' },
    { value: 'Antarctica/Rothera', key: 'timezones.Antarctica-Rothera' },
    { value: 'Antarctica/South_Pole', key: 'timezones.Antarctica-South_Pole' },
    { value: 'Antarctica/Syowa', key: 'timezones.Antarctica-Syowa' },
    { value: 'Antarctica/Troll', key: 'timezones.Antarctica-Troll' },
    { value: 'Antarctica/Vostok', key: 'timezones.Antarctica-Vostok' },
    { value: 'Arctic/Longyearbyen', key: 'timezones.Arctic-Longyearbyen' },
    { value: 'Asia/Aden', key: 'timezones.Asia-Aden' },
    { value: 'Asia/Almaty', key: 'timezones.Asia-Almaty' },
    { value: 'Asia/Amman', key: 'timezones.Asia-Amman' },
    { value: 'Asia/Anadyr', key: 'timezones.Asia-Anadyr' },
    { value: 'Asia/Aqtau', key: 'timezones.Asia-Aqtau' },
    { value: 'Asia/Aqtobe', key: 'timezones.Asia-Aqtobe' },
    { value: 'Asia/Ashgabat', key: 'timezones.Asia-Ashgabat' },
    { value: 'Asia/Ashkhabad', key: 'timezones.Asia-Ashkhabad' },
    { value: 'Asia/Atyrau', key: 'timezones.Asia-Atyrau' },
    { value: 'Asia/Baghdad', key: 'timezones.Asia-Baghdad' },
    { value: 'Asia/Bahrain', key: 'timezones.Asia-Bahrain' },
    { value: 'Asia/Baku', key: 'timezones.Asia-Baku' },
    { value: 'Asia/Bangkok', key: 'timezones.Asia-Bangkok' },
    { value: 'Asia/Barnaul', key: 'timezones.Asia-Barnaul' },
    { value: 'Asia/Beirut', key: 'timezones.Asia-Beirut' },
    { value: 'Asia/Bishkek', key: 'timezones.Asia-Bishkek' },
    { value: 'Asia/Brunei', key: 'timezones.Asia-Brunei' },
    { value: 'Asia/Calcutta', key: 'timezones.Asia-Calcutta' },
    { value: 'Asia/Chita', key: 'timezones.Asia-Chita' },
    { value: 'Asia/Choibalsan', key: 'timezones.Asia-Choibalsan' },
    { value: 'Asia/Chongqing', key: 'timezones.Asia-Chongqing' },
    { value: 'Asia/Chungking', key: 'timezones.Asia-Chungking' },
    { value: 'Asia/Colombo', key: 'timezones.Asia-Colombo' },
    { value: 'Asia/Dacca', key: 'timezones.Asia-Dacca' },
    { value: 'Asia/Damascus', key: 'timezones.Asia-Damascus' },
    { value: 'Asia/Dhaka', key: 'timezones.Asia-Dhaka' },
    { value: 'Asia/Dili', key: 'timezones.Asia-Dili' },
    { value: 'Asia/Dubai', key: 'timezones.Asia-Dubai' },
    { value: 'Asia/Dushanbe', key: 'timezones.Asia-Dushanbe' },
    { value: 'Asia/Famagusta', key: 'timezones.Asia-Famagusta' },
    { value: 'Asia/Gaza', key: 'timezones.Asia-Gaza' },
    { value: 'Asia/Harbin', key: 'timezones.Asia-Harbin' },
    { value: 'Asia/Hebron', key: 'timezones.Asia-Hebron' },
    { value: 'Asia/Ho_Chi_Minh', key: 'timezones.Asia-Ho_Chi_Minh' },
    { value: 'Asia/Hong_Kong', key: 'timezones.Asia-Hong_Kong' },
    { value: 'Asia/Hovd', key: 'timezones.Asia-Hovd' },
    { value: 'Asia/Irkutsk', key: 'timezones.Asia-Irkutsk' },
    { value: 'Asia/Istanbul', key: 'timezones.Asia-Istanbul' },
    { value: 'Asia/Jakarta', key: 'timezones.Asia-Jakarta' },
    { value: 'Asia/Jayapura', key: 'timezones.Asia-Jayapura' },
    { value: 'Asia/Jerusalem', key: 'timezones.Asia-Jerusalem' },
    { value: 'Asia/Kabul', key: 'timezones.Asia-Kabul' },
    { value: 'Asia/Kamchatka', key: 'timezones.Asia-Kamchatka' },
    { value: 'Asia/Karachi', key: 'timezones.Asia-Karachi' },
    { value: 'Asia/Kashgar', key: 'timezones.Asia-Kashgar' },
    { value: 'Asia/Kathmandu', key: 'timezones.Asia-Kathmandu' },
    { value: 'Asia/Katmandu', key: 'timezones.Asia-Katmandu' },
    { value: 'Asia/Khandyga', key: 'timezones.Asia-Khandyga' },
    { value: 'Asia/Kolkata', key: 'timezones.Asia-Kolkata' },
    { value: 'Asia/Krasnoyarsk', key: 'timezones.Asia-Krasnoyarsk' },
    { value: 'Asia/Kuala_Lumpur', key: 'timezones.Asia-Kuala_Lumpur' },
    { value: 'Asia/Kuching', key: 'timezones.Asia-Kuching' },
    { value: 'Asia/Kuwait', key: 'timezones.Asia-Kuwait' },
    { value: 'Asia/Macao', key: 'timezones.Asia-Macao' },
    { value: 'Asia/Macau', key: 'timezones.Asia-Macau' },
    { value: 'Asia/Magadan', key: 'timezones.Asia-Magadan' },
    { value: 'Asia/Makassar', key: 'timezones.Asia-Makassar' },
    { value: 'Asia/Manila', key: 'timezones.Asia-Manila' },
    { value: 'Asia/Muscat', key: 'timezones.Asia-Muscat' },
    { value: 'Asia/Nicosia', key: 'timezones.Asia-Nicosia' },
    { value: 'Asia/Novokuznetsk', key: 'timezones.Asia-Novokuznetsk' },
    { value: 'Asia/Novosibirsk', key: 'timezones.Asia-Novosibirsk' },
    { value: 'Asia/Omsk', key: 'timezones.Asia-Omsk' },
    { value: 'Asia/Oral', key: 'timezones.Asia-Oral' },
    { value: 'Asia/Phnom_Penh', key: 'timezones.Asia-Phnom_Penh' },
    { value: 'Asia/Pontianak', key: 'timezones.Asia-Pontianak' },
    { value: 'Asia/Pyongyang', key: 'timezones.Asia-Pyongyang' },
    { value: 'Asia/Qatar', key: 'timezones.Asia-Qatar' },
    { value: 'Asia/Qostanay', key: 'timezones.Asia-Qostanay' },
    { value: 'Asia/Qyzylorda', key: 'timezones.Asia-Qyzylorda' },
    { value: 'Asia/Rangoon', key: 'timezones.Asia-Rangoon' },
    { value: 'Asia/Riyadh', key: 'timezones.Asia-Riyadh' },
    { value: 'Asia/Saigon', key: 'timezones.Asia-Saigon' },
    { value: 'Asia/Sakhalin', key: 'timezones.Asia-Sakhalin' },
    { value: 'Asia/Samarkand', key: 'timezones.Asia-Samarkand' },
    { value: 'Asia/Seoul', key: 'timezones.Asia-Seoul' },
    { value: 'Asia/Shanghai', key: 'timezones.Asia-Shanghai' },
    { value: 'Asia/Singapore', key: 'timezones.Asia-Singapore' },
    { value: 'Asia/Srednekolymsk', key: 'timezones.Asia-Srednekolymsk' },
    { value: 'Asia/Taipei', key: 'timezones.Asia-Taipei' },
    { value: 'Asia/Tashkent', key: 'timezones.Asia-Tashkent' },
    { value: 'Asia/Tbilisi', key: 'timezones.Asia-Tbilisi' },
    { value: 'Asia/Tehran', key: 'timezones.Asia-Tehran' },
    { value: 'Asia/Tel_Aviv', key: 'timezones.Asia-Tel_Aviv' },
    { value: 'Asia/Thimbu', key: 'timezones.Asia-Thimbu' },
    { value: 'Asia/Thimphu', key: 'timezones.Asia-Thimphu' },
    { value: 'Asia/Tokyo', key: 'timezones.Asia-Tokyo' },
    { value: 'Asia/Tomsk', key: 'timezones.Asia-Tomsk' },
    { value: 'Asia/Ujung_Pandang', key: 'timezones.Asia-Ujung_Pandang' },
    { value: 'Asia/Ulaanbaatar', key: 'timezones.Asia-Ulaanbaatar' },
    { value: 'Asia/Ulan_Bator', key: 'timezones.Asia-Ulan_Bator' },
    { value: 'Asia/Urumqi', key: 'timezones.Asia-Urumqi' },
    { value: 'Asia/Ust-Nera', key: 'timezones.Asia-Ust-Nera' },
    { value: 'Asia/Vientiane', key: 'timezones.Asia-Vientiane' },
    { value: 'Asia/Vladivostok', key: 'timezones.Asia-Vladivostok' },
    { value: 'Asia/Yakutsk', key: 'timezones.Asia-Yakutsk' },
    { value: 'Asia/Yangon', key: 'timezones.Asia-Yangon' },
    { value: 'Asia/Yekaterinburg', key: 'timezones.Asia-Yekaterinburg' },
    { value: 'Asia/Yerevan', key: 'timezones.Asia-Yerevan' },
    { value: 'Atlantic/Azores', key: 'timezones.Atlantic-Azores' },
    { value: 'Atlantic/Bermuda', key: 'timezones.Atlantic-Bermuda' },
    { value: 'Atlantic/Canary', key: 'timezones.Atlantic-Canary' },
    { value: 'Atlantic/Cape_Verde', key: 'timezones.Atlantic-Cape_Verde' },
    { value: 'Atlantic/Faeroe', key: 'timezones.Atlantic-Faeroe' },
    { value: 'Atlantic/Faroe', key: 'timezones.Atlantic-Faroe' },
    { value: 'Atlantic/Jan_Mayen', key: 'timezones.Atlantic-Jan_Mayen' },
    { value: 'Atlantic/Madeira', key: 'timezones.Atlantic-Madeira' },
    { value: 'Atlantic/Reykjavik', key: 'timezones.Atlantic-Reykjavik' },
    { value: 'Atlantic/South_Georgia', key: 'timezones.Atlantic-South_Georgia' },
    { value: 'Atlantic/St_Helena', key: 'timezones.Atlantic-St_Helena' },
    { value: 'Atlantic/Stanley', key: 'timezones.Atlantic-Stanley' },
    { value: 'Australia/Adelaide', key: 'timezones.Australia-Adelaide' },
    { value: 'Australia/Brisbane', key: 'timezones.Australia-Brisbane' },
    { value: 'Australia/Broken_Hill', key: 'timezones.Australia-Broken_Hill' },
    { value: 'Australia/Canberra', key: 'timezones.Australia-Canberra' },
    { value: 'Australia/Currie', key: 'timezones.Australia-Currie' },
    { value: 'Australia/Darwin', key: 'timezones.Australia-Darwin' },
    { value: 'Australia/Eucla', key: 'timezones.Australia-Eucla' },
    { value: 'Australia/Hobart', key: 'timezones.Australia-Hobart' },
    { value: 'Australia/Lindeman', key: 'timezones.Australia-Lindeman' },
    { value: 'Australia/Lord_Howe', key: 'timezones.Australia-Lord_Howe' },
    { value: 'Australia/Melbourne', key: 'timezones.Australia-Melbourne' },
    { value: 'Australia/North', key: 'timezones.Australia-North' },
    { value: 'Australia/Perth', key: 'timezones.Australia-Perth' },
    { value: 'Australia/Queensland', key: 'timezones.Australia-Queensland' },
    { value: 'Australia/South', key: 'timezones.Australia-South' },
    { value: 'Australia/Sydney', key: 'timezones.Australia-Sydney' },
    { value: 'Australia/Tasmania', key: 'timezones.Australia-Tasmania' },
    { value: 'Australia/Victoria', key: 'timezones.Australia-Victoria' },
    { value: 'Australia/West', key: 'timezones.Australia-West' },
    { value: 'Australia/Yancowinna', key: 'timezones.Australia-Yancowinna' },
    { value: 'Brazil/Acre', key: 'timezones.Brazil-Acre' },
    { value: 'Brazil/East', key: 'timezones.Brazil-East' },
    { value: 'Brazil/West', key: 'timezones.Brazil-West' },
    { value: 'Canada/Atlantic', key: 'timezones.Canada-Atlantic' },
    { value: 'Canada/Central', key: 'timezones.Canada-Central' },
    { value: 'Canada/Eastern', key: 'timezones.Canada-Eastern' },
    { value: 'Canada/Mountain', key: 'timezones.Canada-Mountain' },
    { value: 'Canada/Newfoundland', key: 'timezones.Canada-Newfoundland' },
    { value: 'Canada/Pacific', key: 'timezones.Canada-Pacific' },
    { value: 'Canada/Saskatchewan', key: 'timezones.Canada-Saskatchewan' },
    { value: 'Canada/Yukon', key: 'timezones.Canada-Yukon' },
    { value: 'Chile/Continental', key: 'timezones.Chile-Continental' },
    { value: 'Cuba', key: 'timezones.Cuba' },
    { value: 'Egypt', key: 'timezones.Egypt' },
    { value: 'Eire', key: 'timezones.Eire' },
    { value: 'Etc/GMT', key: 'timezones.Etc-GMT' },
    { value: 'Etc/GMT+0', key: 'timezones.Etc-GMT+0' },
    { value: 'Etc/GMT+1', key: 'timezones.Etc-GMT+1' },
    { value: 'Etc/GMT+10', key: 'timezones.Etc-GMT+10' },
    { value: 'Etc/GMT+11', key: 'timezones.Etc-GMT+11' },
    { value: 'Etc/GMT+12', key: 'timezones.Etc-GMT+12' },
    { value: 'Etc/GMT+2', key: 'timezones.Etc-GMT+2' },
    { value: 'Etc/GMT+3', key: 'timezones.Etc-GMT+3' },
    { value: 'Etc/GMT+4', key: 'timezones.Etc-GMT+4' },
    { value: 'Etc/GMT+5', key: 'timezones.Etc-GMT+5' },
    { value: 'Etc/GMT+6', key: 'timezones.Etc-GMT+6' },
    { value: 'Etc/GMT+7', key: 'timezones.Etc-GMT+7' },
    { value: 'Etc/GMT+8', key: 'timezones.Etc-GMT+8' },
    { value: 'Etc/GMT+9', key: 'timezones.Etc-GMT+9' },
    { value: 'Etc/GMT-0', key: 'timezones.Etc-GMT-0' },
    { value: 'Etc/GMT-1', key: 'timezones.Etc-GMT-1' },
    { value: 'Etc/GMT-10', key: 'timezones.Etc-GMT-10' },
    { value: 'Etc/GMT-11', key: 'timezones.Etc-GMT-11' },
    { value: 'Etc/GMT-12', key: 'timezones.Etc-GMT-12' },
    { value: 'Etc/GMT-13', key: 'timezones.Etc-GMT-13' },
    { value: 'Etc/GMT-14', key: 'timezones.Etc-GMT-14' },
    { value: 'Etc/GMT-2', key: 'timezones.Etc-GMT-2' },
    { value: 'Etc/GMT-3', key: 'timezones.Etc-GMT-3' },
    { value: 'Etc/GMT-4', key: 'timezones.Etc-GMT-4' },
    { value: 'Etc/GMT-5', key: 'timezones.Etc-GMT-5' },
    { value: 'Etc/GMT-6', key: 'timezones.Etc-GMT-6' },
    { value: 'Etc/GMT-7', key: 'timezones.Etc-GMT-7' },
    { value: 'Etc/GMT-8', key: 'timezones.Etc-GMT-8' },
    { value: 'Etc/GMT-9', key: 'timezones.Etc-GMT-9' },
    { value: 'Etc/GMT0', key: 'timezones.Etc-GMT0' },
    { value: 'Etc/Greenwich', key: 'timezones.Etc-Greenwich' },
    { value: 'Etc/UTC', key: 'timezones.Etc-UTC' },
    { value: 'Etc/Universal', key: 'timezones.Etc-Universal' },
    { value: 'Etc/Zulu', key: 'timezones.Etc-Zulu' },
    { value: 'Europe/Amsterdam', key: 'timezones.Europe-Amsterdam' },
    { value: 'Europe/Andorra', key: 'timezones.Europe-Andorra' },
    { value: 'Europe/Astrakhan', key: 'timezones.Europe-Astrakhan' },
    { value: 'Europe/Athens', key: 'timezones.Europe-Athens' },
    { value: 'Europe/Belfast', key: 'timezones.Europe-Belfast' },
    { value: 'Europe/Belgrade', key: 'timezones.Europe-Belgrade' },
    { value: 'Europe/Berlin', key: 'timezones.Europe-Berlin' },
    { value: 'Europe/Bratislava', key: 'timezones.Europe-Bratislava' },
    { value: 'Europe/Brussels', key: 'timezones.Europe-Brussels' },
    { value: 'Europe/Bucharest', key: 'timezones.Europe-Bucharest' },
    { value: 'Europe/Budapest', key: 'timezones.Europe-Budapest' },
    { value: 'Europe/Busingen', key: 'timezones.Europe-Busingen' },
    { value: 'Europe/Chisinau', key: 'timezones.Europe-Chisinau' },
    { value: 'Europe/Copenhagen', key: 'timezones.Europe-Copenhagen' },
    { value: 'Europe/Dublin', key: 'timezones.Europe-Dublin' },
    { value: 'Europe/Gibraltar', key: 'timezones.Europe-Gibraltar' },
    { value: 'Europe/Guernsey', key: 'timezones.Europe-Guernsey' },
    { value: 'Europe/Helsinki', key: 'timezones.Europe-Helsinki' },
    { value: 'Europe/Isle_of_Man', key: 'timezones.Europe-Isle_of_Man' },
    { value: 'Europe/Istanbul', key: 'timezones.Europe-Istanbul' },
    { value: 'Europe/Jersey', key: 'timezones.Europe-Jersey' },
    { value: 'Europe/Kaliningrad', key: 'timezones.Europe-Kaliningrad' },
    { value: 'Europe/Kiev', key: 'timezones.Europe-Kiev' },
    { value: 'Europe/Kirov', key: 'timezones.Europe-Kirov' },
    { value: 'Europe/Lisbon', key: 'timezones.Europe-Lisbon' },
    { value: 'Europe/Ljubljana', key: 'timezones.Europe-Ljubljana' },
    { value: 'Europe/London', key: 'timezones.Europe-London' },
    { value: 'Europe/Luxembourg', key: 'timezones.Europe-Luxembourg' },
    { value: 'Europe/Madrid', key: 'timezones.Europe-Madrid' },
    { value: 'Europe/Malta', key: 'timezones.Europe-Malta' },
    { value: 'Europe/Mariehamn', key: 'timezones.Europe-Mariehamn' },
    { value: 'Europe/Minsk', key: 'timezones.Europe-Minsk' },
    { value: 'Europe/Monaco', key: 'timezones.Europe-Monaco' },
    { value: 'Europe/Moscow', key: 'timezones.Europe-Moscow' },
    { value: 'Europe/Nicosia', key: 'timezones.Europe-Nicosia' },
    { value: 'Europe/Oslo', key: 'timezones.Europe-Oslo' },
    { value: 'Europe/Paris', key: 'timezones.Europe-Paris' },
    { value: 'Europe/Podgorica', key: 'timezones.Europe-Podgorica' },
    { value: 'Europe/Prague', key: 'timezones.Europe-Prague' },
    { value: 'Europe/Riga', key: 'timezones.Europe-Riga' },
    { value: 'Europe/Rome', key: 'timezones.Europe-Rome' },
    { value: 'Europe/Samara', key: 'timezones.Europe-Samara' },
    { value: 'Europe/San_Marino', key: 'timezones.Europe-San_Marino' },
    { value: 'Europe/Sarajevo', key: 'timezones.Europe-Sarajevo' },
    { value: 'Europe/Saratov', key: 'timezones.Europe-Saratov' },
    { value: 'Europe/Simferopol', key: 'timezones.Europe-Simferopol' },
    { value: 'Europe/Skopje', key: 'timezones.Europe-Skopje' },
    { value: 'Europe/Sofia', key: 'timezones.Europe-Sofia' },
    { value: 'Europe/Stockholm', key: 'timezones.Europe-Stockholm' },
    { value: 'Europe/Tallinn', key: 'timezones.Europe-Tallinn' },
    { value: 'Europe/Tirane', key: 'timezones.Europe-Tirane' },
    { value: 'Europe/Tiraspol', key: 'timezones.Europe-Tiraspol' },
    { value: 'Europe/Ulyanovsk', key: 'timezones.Europe-Ulyanovsk' },
    { value: 'Europe/Uzhgorod', key: 'timezones.Europe-Uzhgorod' },
    { value: 'Europe/Vaduz', key: 'timezones.Europe-Vaduz' },
    { value: 'Europe/Vatican', key: 'timezones.Europe-Vatican' },
    { value: 'Europe/Vienna', key: 'timezones.Europe-Vienna' },
    { value: 'Europe/Vilnius', key: 'timezones.Europe-Vilnius' },
    { value: 'Europe/Volgograd', key: 'timezones.Europe-Volgograd' },
    { value: 'Europe/Warsaw', key: 'timezones.Europe-Warsaw' },
    { value: 'Europe/Zagreb', key: 'timezones.Europe-Zagreb' },
    { value: 'Europe/Zaporozhye', key: 'timezones.Europe-Zaporozhye' },
    { value: 'Europe/Zurich', key: 'timezones.Europe-Zurich' },
    { value: 'GMT', key: 'timezones.GMT' },
    { value: 'Greenwich', key: 'timezones.Greenwich' },
    { value: 'Hongkong', key: 'timezones.Hongkong' },
    { value: 'Iceland', key: 'timezones.Iceland' },
    { value: 'Indian/Antananarivo', key: 'timezones.Indian-Antananarivo' },
    { value: 'Indian/Chagos', key: 'timezones.Indian-Chagos' },
    { value: 'Indian/Christmas', key: 'timezones.Indian-Christmas' },
    { value: 'Indian/Cocos', key: 'timezones.Indian-Cocos' },
    { value: 'Indian/Comoro', key: 'timezones.Indian-Comoro' },
    { value: 'Indian/Kerguelen', key: 'timezones.Indian-Kerguelen' },
    { value: 'Indian/Mahe', key: 'timezones.Indian-Mahe' },
    { value: 'Indian/Maldives', key: 'timezones.Indian-Maldives' },
    { value: 'Indian/Mauritius', key: 'timezones.Indian-Mauritius' },
    { value: 'Indian/Mayotte', key: 'timezones.Indian-Mayotte' },
    { value: 'Indian/Reunion', key: 'timezones.Indian-Reunion' },
    { value: 'Iran', key: 'timezones.Iran' },
    { value: 'Israel', key: 'timezones.Israel' },
    { value: 'Jamaica', key: 'timezones.Jamaica' },
    { value: 'Japan', key: 'timezones.Japan' },
    { value: 'Kwajalein', key: 'timezones.Kwajalein' },
    { value: 'Libya', key: 'timezones.Libya' },
    { value: 'Mexico/General', key: 'timezones.Mexico-General' },
    { value: 'Navajo', key: 'timezones.Navajo' },
    { value: 'Pacific/Apia', key: 'timezones.Pacific-Apia' },
    { value: 'Pacific/Auckland', key: 'timezones.Pacific-Auckland' },
    { value: 'Pacific/Bougainville', key: 'timezones.Pacific-Bougainville' },
    { value: 'Pacific/Chatham', key: 'timezones.Pacific-Chatham' },
    { value: 'Pacific/Chuuk', key: 'timezones.Pacific-Chuuk' },
    { value: 'Pacific/Easter', key: 'timezones.Pacific-Easter' },
    { value: 'Pacific/Efate', key: 'timezones.Pacific-Efate' },
    { value: 'Pacific/Enderbury', key: 'timezones.Pacific-Enderbury' },
    { value: 'Pacific/Fakaofo', key: 'timezones.Pacific-Fakaofo' },
    { value: 'Pacific/Fiji', key: 'timezones.Pacific-Fiji' },
    { value: 'Pacific/Funafuti', key: 'timezones.Pacific-Funafuti' },
    { value: 'Pacific/Galapagos', key: 'timezones.Pacific-Galapagos' },
    { value: 'Pacific/Gambier', key: 'timezones.Pacific-Gambier' },
    { value: 'Pacific/Guadalcanal', key: 'timezones.Pacific-Guadalcanal' },
    { value: 'Pacific/Guam', key: 'timezones.Pacific-Guam' },
    { value: 'Pacific/Honolulu', key: 'timezones.Pacific-Honolulu' },
    { value: 'Pacific/Johnston', key: 'timezones.Pacific-Johnston' },
    { value: 'Pacific/Kiritimati', key: 'timezones.Pacific-Kiritimati' },
    { value: 'Pacific/Kosrae', key: 'timezones.Pacific-Kosrae' },
    { value: 'Pacific/Kwajalein', key: 'timezones.Pacific-Kwajalein' },
    { value: 'Pacific/Majuro', key: 'timezones.Pacific-Majuro' },
    { value: 'Pacific/Marquesas', key: 'timezones.Pacific-Marquesas' },
    { value: 'Pacific/Midway', key: 'timezones.Pacific-Midway' },
    { value: 'Pacific/Nauru', key: 'timezones.Pacific-Nauru' },
    { value: 'Pacific/Niue', key: 'timezones.Pacific-Niue' },
    { value: 'Pacific/Norfolk', key: 'timezones.Pacific-Norfolk' },
    { value: 'Pacific/Noumea', key: 'timezones.Pacific-Noumea' },
    { value: 'Pacific/Pago_Pago', key: 'timezones.Pacific-Pago_Pago' },
    { value: 'Pacific/Palau', key: 'timezones.Pacific-Palau' },
    { value: 'Pacific/Pitcairn', key: 'timezones.Pacific-Pitcairn' },
    { value: 'Pacific/Pohnpei', key: 'timezones.Pacific-Pohnpei' },
    { value: 'Pacific/Ponape', key: 'timezones.Pacific-Ponape' },
    { value: 'Pacific/Port_Moresby', key: 'timezones.Pacific-Port_Moresby' },
    { value: 'Pacific/Rarotonga', key: 'timezones.Pacific-Rarotonga' },
    { value: 'Pacific/Saipan', key: 'timezones.Pacific-Saipan' },
    { value: 'Pacific/Samoa', key: 'timezones.Pacific-Samoa' },
    { value: 'Pacific/Tahiti', key: 'timezones.Pacific-Tahiti' },
    { value: 'Pacific/Tarawa', key: 'timezones.Pacific-Tarawa' },
    { value: 'Pacific/Tongatapu', key: 'timezones.Pacific-Tongatapu' },
    { value: 'Pacific/Truk', key: 'timezones.Pacific-Truk' },
    { value: 'Pacific/Wake', key: 'timezones.Pacific-Wake' },
    { value: 'Pacific/Wallis', key: 'timezones.Pacific-Wallis' },
    { value: 'Pacific/Yap', key: 'timezones.Pacific-Yap' },
    { value: 'Poland', key: 'timezones.Poland' },
    { value: 'Portugal', key: 'timezones.Portugal' },
    { value: 'Singapore', key: 'timezones.Singapore' },
    { value: 'Turkey', key: 'timezones.Turkey' },
    { value: 'UTC', key: 'timezones.UTC' },
    { value: 'Universal', key: 'timezones.Universal' },
    { value: 'Zulu', key: 'timezones.Zulu' }
];
